import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

import getPage from 'later/utils/get-page-from-window';

import type RouterService from '@ember/routing/router-service';
import type AuthService from 'later/services/auth';
import type ChatbotWrapperService from 'later/services/chatbot/chatbot-wrapper';
import type IntegrationsQueueService from 'later/services/integrations-queue';

export default class ClusterController extends Controller {
  @service declare auth: AuthService;
  @service declare integrationsQueue: IntegrationsQueueService;
  @service declare router: RouterService;
  @service('chatbot/chatbot-wrapper') declare chatbotWrapper: ChatbotWrapperService;

  get hideAppNavigation(): boolean {
    return this.isOnUnsubscribeRoute || this.isOnCampaignApplicationRoute;
  }

  get isOnCampaignApplicationRoute(): boolean {
    return this.router.currentRouteName.includes('partnerships.campaign-application');
  }

  get isOnUnsubscribeRoute(): boolean {
    return this.router.currentRouteName.endsWith('unsubscribe');
  }

  /**
   * Flag to indicate if the page content is responsive
   */
  get isPageContentResponsive(): boolean {
    return this.router.currentRouteName.includes('cluster.custom-analytics');
  }

  @action
  openChatbot(location: string): void {
    this.integrationsQueue.addToQueue(this.chatbotWrapper.name, true);

    this.chatbotWrapper.open(location, getPage());
  }

  @action
  logout(): void {
    this.auth.logout.perform();
  }
}
